/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getUserIntent} from '../api'

 export const useQueryGetUserIntent = createReactQueryHook('getUserIntent', getUserIntent)
